import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const ILIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="IL" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#F7FCFF"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G fill="#3D58DB" mask="url(#b)">
        <Path
          fillRule="evenodd"
          d="M0 2v1.783h16V2H0ZM0 8.174V10h16V8.174H0Z"
          clipRule="evenodd"
        />
        <Path d="M10.379 7.469H5.691l2.367-4.01 2.321 4.01Zm-3.726-.55h2.772L8.053 4.55l-1.4 2.37Z" />
        <Path d="M10.34 4.463H5.547l2.522 4.023 2.273-4.023Zm-3.8.55h2.858L8.043 7.41 6.54 5.013Z" />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
